// extracted by mini-css-extract-plugin
module.exports = {"PrintPDF":"PrintPDF_PrintPDF__iAD5D","imgWrapper":"PrintPDF_imgWrapper__1QNJT","wrapper":"PrintPDF_wrapper__2u0kY","pdfLoading":"PrintPDF_pdfLoading__2LeO8"};